import React, { forwardRef } from 'react';
import EmbedVideo from 'components/embed-video';
import Grid from 'components/grid';
import PropTypes from 'prop-types';

const ProductVideo = forwardRef(({ videoUrl }, ref) =>
  videoUrl ? (
    <div className="product-video">
      <Grid
        className="product-features-and-technology__content"
        theme={Grid.themes.leftColumnWider}
      >
        <Grid.Column className="product-video__col">
          <EmbedVideo ref={ref} url={videoUrl} />
        </Grid.Column>
      </Grid>
    </div>
  ) : null
);

ProductVideo.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
  videoUrl: PropTypes.string
};

export default ProductVideo;
